import React, {FC} from 'react'

interface CardIconProps {
  className?: string
}

export const CardIcon: FC<CardIconProps> = ({className}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="3.5" y="5.5" width="17" height="13" rx="1.5" />
    <path d="M3.5 9.5h17" />
    <path d="M6.5 14.5h6" />
  </svg>
)
